import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import UserContext from "../context/userContext";
import SidebarContext from "../context/sidebarContext";
import "../App.css";

const Sidebar = (props) => {
  const [user] = useContext(UserContext);
  const [display] = useContext(SidebarContext);

  if (!display) return null;

  var open = 0;
  var pendingClose = 0;

  if (props.ccf) {
    open = props.ccf.open;
    pendingClose = props.ccf.pendingClose;
  }

  return (
    <React.Fragment>
      <div className="sidebar col-2 text-white px-0 d-print-none">
        <div className="sticky-top vh-100 overflow-auto">
          <ul className="list-group list-group-flush">
            {user && user.VIEW_DATA_SCREENS && user.SITE !== "CO" && (
              <li className="nav-link-item d-flex">
                <NavLink
                  exact
                  to="/dataentry"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-feather-alt pr-1" /> Data Entry
                  </div>
                </NavLink>
              {user && user.MAINTAIN_DATA_SCREENS && user.Site !== "CO" && (
                <NavLink
                  to="/dataentry/manage"
                  className="nav-link-cog"
                >
                  <div>
                    <i className="fas fa-cog" />
                  </div>
                </NavLink>
              )}
              </li>
            )}

            {user && user.VIEW_DASHBOARDS && (
              <li className="nav-link-item d-flex">
                <NavLink
                  exact
                  to="/dashboards"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-chart-line pr-1" /> Dashboards
                  </div>
                </NavLink>
                {user && user.MAINTAIN_DASHBOARDS && (
                    <NavLink
                      to="/dashboards/manage"
                      className="nav-link-cog"
                    >
                      <div>
                        <i className="fas fa-cog" />
                      </div>
                    </NavLink>
                  )}
              </li>
            )}

            {user && user.LIVE_DATA && (
              <li className="nav-link-item d-flex justify-content-between">
                <NavLink
                  to="/live"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-chart-bar pr-1" /> Live Data
                  </div>
                </NavLink>
              </li>
            )}

            {user && user.REPORTS && (
              <li className="nav-link-item d-flex">
                <NavLink
                  to="/reports"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-file pr-1" /> Reports
                  </div>
                </NavLink>
                {user && user.MAINTAIN_REPORTS && (
                  <NavLink
                    to="/report/manage"
                    className="nav-link-cog"
                  >
                    <div>
                      <i className="fas fa-cog" />
                    </div>
                  </NavLink>
                )}
              </li>
            )}

            {user && user.DATA_GRABBER && (
              <li className="nav-link-item d-flex">
                <NavLink
                  exact
                  to="/datagrabber"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-chart-bar pr-1" /> Data Grabber
                  </div>
                </NavLink>
                {user && user.MAINTAIN_GRABBERS && (
                  <NavLink
                    to="/datagrabber/manage"
                    className="nav-link-cog"
                  >
                    <div>
                      <i className="fas fa-cog" />
                    </div>
                  </NavLink>
                )}
              </li>
            )}

            {user && user.REPORTS && (
              <li className="nav-link-item d-flex">
              <NavLink
                to="/summary"
                className="nav-link-entry"
              >
                <div>
                  <i className="fas fa-plus pr-1" /> Data Summary
                </div>
              </NavLink>
              </li>
            )}
            {user && (
              <li className="nav-link-item d-flex">
              <NavLink
                to="/parameters"
                className="nav-link-entry"
              >
                <div>
                  <i className="fas fa-key pr-1" /> Parameters
                </div>
              </NavLink>
              </li>
            )}

            {user && user.OPERATIONS && (
              <li className="nav-link-item d-flex">
                <NavLink
                  to="/operations"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="far fa-calendar-alt pr-1" /> Operations
                  </div>
                </NavLink>
              </li>
            )}

            {user && user.CONSTANTS && (
              <li className="nav-link-item d-flex">
                <NavLink
                  to="/constants"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-sync" /> Constants
                  </div>
                </NavLink>
              </li>
            )}

            {user && user.LOOKUPS && (
              <li className="nav-link-item d-flex">
                <NavLink
                  to="/lookups"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-search pr-1" /> Lookups
                  </div>
                </NavLink>
              </li>
            )}
            
            {user && user.USERS && (
              <li className="nav-link-item d-flex">
                <NavLink
                  to="/users"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-users pr-1" /> Users
                  </div>
                </NavLink>
              </li>
            )}
            
            {user && user.PRODUCTION_COMMENTS && (
              <li className="nav-link-item d-flex">
                <NavLink
                  to="/twitter"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-paper-plane pr-1" /> Production Comments
                  </div>
                </NavLink>
              </li>
            )}
            
            {user && user.PARAMETERS && user.SITE !== "CO" && (
              <li className="nav-link-item d-flex">
                <NavLink
                  to="/processtags"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-circle pr-1" /> Process Tags
                  </div>
                </NavLink>
              </li>
            )}
            
            {user && user.VIEW_CCF && user.SITE !== "CO" && (
              <li className="nav-link-item d-flex">
                <NavLink
                  exact
                  to="/ccf"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-chart-line pr-1" /> CCFs {open > 0 
                      ? <span className="badge badge-warning" style={{marginLeft: '24px'}}>{open}</span>
                      : <span />} {pendingClose > 0 
                        ? <span className="badge badge-primary style={{marginLeft: '24px'}}">{pendingClose}</span>
                        : <span />}
                  </div>
                </NavLink>
                {user && user.MAINTAIN_CCF && (
                  <NavLink to="/ccf/settings" className="nav-link-cog">
                    <div>
                      <i className="fas fa-cog pr-1" />
                    </div>
                  </NavLink>
                )}
              </li>
            )}
            
            {user && user.RECALCULATE && user.SITE !== "CO" && (
              <li className="nav-link-item d-flex">
                <NavLink
                  to="/recalculate"
                  className="nav-link-entry"
                >
                  <div>
                    <i className="fas fa-square pr-1" /> Recalculate
                  </div>
                </NavLink>
              </li>
            )}
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
